import { FaCheck } from "react-icons/fa";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { APP_ROUTES } from "../services/app_routes";
import FormularioPadrao, { TAMANHO_FORMULARIO } from "../components/FormularioPadrao/FormularioPadrao";
import InputPadrao from "../components/InputPadrao/InputPadrao";
import TogglePadrao from "../components/TogglePadrao/TogglePadrao";
import Mensagens from "../utils/MensagemUtils";
import Carregamento from "../components/Carregamento/Carregamento";
import { TipoFormatacao } from "../utils/FormatacaoUtils";
import NotificacaoUtils from "../utils/NotificacaoUtils";
import api from "../services/api";
import { TipoValidacao, ValidacaoUtils } from "../utils/ValidacaoUtils";
import "./Cadastros.css";

const CadastroEmpresa = ({ isEdit = false }) => {
    const { id } = useParams(); // Pega o ID da URL
    const navigate = useNavigate();
    const [carregando, setCarregando] = useState(false);
    const [dadosEmpresaCarregados, setDadosEmpresaCarregados] = useState(false);
    const [errors, setErrors] = useState({});

    const carregamentoGeral = () => {
      return carregando;
    };

    const [empresa, setEmpresa] = useState({
      idEmpresa: 0,
      razaoSocial: '',
      cnpj: '',
      situacaoCadastro: true,
      dataCriacao: '',
      dataAlteracao: '',
    });
    
    const buscarEmpresa = async (idEmpresa) => {
      setCarregando(true);
      try {
        const apiResponse = await api.get(`/empresa_/${idEmpresa}`);
        if (apiResponse.success && apiResponse.data) {
          const dadosEmpresa = apiResponse.data;
          
          const situacaoAtiva = dadosEmpresa.situacaoCadastro === "ATIVO";
          
          setEmpresa({
            ...dadosEmpresa,
            situacaoCadastro: situacaoAtiva
          });
          
          setDadosEmpresaCarregados(true);
        } else {
          NotificacaoUtils.erro(Mensagens.EMPRESA.ERRO.CARREGAR);
          navigate(APP_ROUTES.EMPRESA_VISUALIZAR);
        }
      } catch (error) {
        console.error("Erro ao carregar empresa:", error);
        NotificacaoUtils.erro(Mensagens.EMPRESA.ERRO.CARREGAR);
        navigate(APP_ROUTES.EMPRESA_VISUALIZAR);
      } finally {
        setCarregando(false);
      }
    };
    
    useEffect(() => {
      if (isEdit && id && !dadosEmpresaCarregados) {
        buscarEmpresa(id);
      }
    }, [isEdit, id, dadosEmpresaCarregados]);
    
    const handleInputChange = (e, field) => {
      setEmpresa({
        ...empresa,
        [field]: e.target.value,
      });

      if (errors[field]) {
        setErrors({
          ...errors,
          [field]: null,
        });
      }
    };

    const handleSwitchChange = (novoValor, field) => {
      setEmpresa({
        ...empresa,
        [field]: novoValor,
      });
    };

    const validarFormulario = () => {
      const retornoValidacao = ValidacaoUtils.validateForm(
        empresa,
        TipoValidacao.EMPRESA_CRIAR
      );

      if (!retornoValidacao.success) {
        setErrors(retornoValidacao.errors);
        return false;
      }

      return true;
    };

    const handleCadastro = async () => {
      if (!validarFormulario()) return;

      setCarregando(true);

      try {
        const dadosEmpresa = {
          idEmpresa: isEdit ? empresa.idEmpresa : 0,
          razaoSocial: empresa.razaoSocial,
          cnpj: empresa.cnpj,
          situacaoCadastro: empresa.situacaoCadastro ? 'ATIVO' : 'INATIVO',
        };

        const apiResponse = isEdit 
          ? await Promise.resolve(api.put(`/empresa_`, dadosEmpresa)) 
          : await Promise.resolve(api.post(`/empresa_`, dadosEmpresa));

        if (!apiResponse.success) {
          NotificacaoUtils.erro(apiResponse.message || Mensagens.EMPRESA.ERRO.ATUALIZAR);
        } else {
          NotificacaoUtils.sucesso(isEdit ? Mensagens.EMPRESA.ATUALIZADO_SUCESSO : Mensagens.EMPRESA.CADASTRADO_SUCESSO);
          navigate(APP_ROUTES.EMPRESA_VISUALIZAR);
        }
      } catch (error) {
        console.error("Erro ao salvar empresa:", error);
        NotificacaoUtils.erro(Mensagens.EMPRESA.ERRO.ATUALIZAR_TENTE_NOVAMENTE);
      } finally {
        setCarregando(false);
      }
    };

    const handleCancel = () => {
      navigate(APP_ROUTES.EMPRESA_VISUALIZAR);
    };

    return (
      <div>
        {carregamentoGeral() && <Carregamento />}

        <FormularioPadrao
          titulo={isEdit ? Mensagens.EMPRESA.EDICAO_TITULO : Mensagens.EMPRESA.CADASTRO_TITULO}
          subtitulo={
            isEdit ? Mensagens.EMPRESA.EDICAO_SUBTITULO : Mensagens.EMPRESA.CADASTRO_SUBTITULO
          }
          tituloInterno={Mensagens.INFORMACOES_GERAIS}
          tamanho={TAMANHO_FORMULARIO.REDUZIDO}
          onSalvar={handleCadastro}
          onCancelar={handleCancel}
          iconeBotao={<FaCheck />}
          dataCriacao={isEdit ? empresa.dataCriacao : null}
          dataAlteracao={isEdit ? empresa.dataAlteracao : null}
        >
          <div className="inputs-flex">
            <div className="linha-flex">
              <InputPadrao
                label={Mensagens.EMPRESA.RAZAO_SOCIAL}
                placeholder={Mensagens.EMPRESA.RAZAO_SOCIAL_PLACEHOLDER}
                required={true}
                value={empresa.razaoSocial}
                erroMensagem={errors.razaoSocial}
                onChange={e => handleInputChange(e, 'razaoSocial')}
              />
            </div>
            <div className="linha-flex"></div>
            <div className="linha-flex">
              <InputPadrao
                label={Mensagens.EMPRESA.DOCUMENTO}
                placeholder={Mensagens.EMPRESA.DOCUMENTO_PLACEHOLDER}
                required={true}
                value={empresa.cnpj}
                tipoFormatador={TipoFormatacao.DOCUMENTO}
                type={InputPadrao.TipoInput.DOCUMENTO}
                erroMensagem={errors.cnpj}
                onChange={e => handleInputChange(e, 'cnpj')}
              />
              <TogglePadrao
                label={Mensagens.EMPRESA.SITUACAO_CADASTRO}
                value={empresa.situacaoCadastro}
                disabled={!isEdit}
                onChange={novoValor => handleSwitchChange(novoValor, 'situacaoCadastro')}
              />
            </div>
          </div>
        </FormularioPadrao>
      </div>
    );
}
 
export default CadastroEmpresa;